export class ChangePassword {
    public signature: string;
    public password: string;
    constructor(data: any = {}) {
        this.signature = data.signature || '';
        this.password = data.password || '';
    }
}